export const WORLD_CUP_MATCHES_REQUEST = 'worldCupMatchesRequest';
export const WORLD_CUP_MATCHES_FAILURE = 'worldCupMatchesFailure';
export const WORLD_CUP_MATCHES_SUCCESS = 'worldCupMatchesSuccess';
